export const EXPERIENCES_LIST = [
  {
    title: 'Software Engineer - Backend',
    time: 'Nov 2022 - present',
    place: 'Pelago (Singapore, Singapore)',
  },
  {
    title: 'Software Engineer - Frontend',
    time: 'Sep 2022 (canceled)',
    place: 'Sea (Singapore, Singapore)',
  },
  {
    title: 'Software Engineer Intern - Mobile',
    time: 'Mar 2022 - Jul 2022',
    place: 'Traveloka (Tangerang, Indonesia)',
  },
  {
    title: 'Solutions Architect Intern',
    time: 'Jun 2021 - Sep 2021',
    place: 'Amazon Web Services (Jakarta, Indonesia)',
  },
  {
    title: 'Software Engineer Intern - Frontend',
    time: 'Feb 2021 - May 2021',
    place: 'GudangAda (Tangerang, Indonesia)',
  },
  {
    title: 'Software Engineer Intern - Backend',
    time: 'Jul 2020 - Oct 2020',
    place: '9cv9 (Ho Chi Minh, Vietnam)',
  },
  {
    title: 'Teaching and Lab Assistant',
    time: 'Sep 2019 - Jun 2022',
    place: 'University of Indonesia (Depok, Indonesia)',
  },
]
